import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Handshake } from 'lucide-react';
const services = [{
  title: 'Нерухоме майно',
  category: 'Квартири, будинки, комерція',
  image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Земельні ділянки',
  category: 'Пай, забудова, сільгосп',
  image: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Рухоме майно',
  category: 'Автомобілі, техніка, обладнання',
  image: 'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?auto=format&fit=crop&q=80&w=800'
}];
export function Services() {
  return <section id="services" className="py-24 md:py-32 px-6" data-id="element-102">
      <div className="max-w-7xl mx-auto" data-id="element-103">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6" data-id="element-104">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-105">
            <h2 className="text-4xl md:text-5xl font-semibold tracking-tight text-gray-900 mb-4" data-id="element-106">
              Що ми оцінюємо
            </h2>
            <p className="text-gray-500 text-lg max-w-2xl font-light" data-id="element-107">
              Надаємо кваліфіковану допомогу при формуванні е-Довідок. При
              необхідності проводимо рецензування Звітів через ФДМУ.
            </p>
          </motion.div>
        </div>

        {/* Main Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-108">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="group cursor-pointer" data-id="element-109">
              <div className="relative overflow-hidden rounded-3xl aspect-[4/3] mb-6 bg-gray-100" data-id="element-110">
                <img src={service.image} alt={service.title} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105" data-id="element-111" />
                <div className="absolute inset-0 bg-black/10 group-hover:bg-transparent transition-colors duration-500" data-id="element-112" />
              </div>
              <div className="flex items-center justify-between px-2" data-id="element-113">
                <div data-id="element-114">
                  <p className="text-sm text-gray-500 mb-1" data-id="element-115">
                    {service.category}
                  </p>
                  <h3 className="text-2xl font-medium text-gray-900" data-id="element-116">
                    {service.title}
                  </h3>
                </div>
                <div className="w-10 h-10 rounded-full border border-gray-200 flex items-center justify-center group-hover:bg-gray-900 group-hover:border-gray-900 group-hover:text-white transition-all duration-300" data-id="element-117">
                  <ArrowRight size={18} data-id="element-118" />
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* B2B Banner */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-24 rounded-[2.5rem] overflow-hidden bg-gray-900 text-white shadow-2xl relative" data-id="element-119">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-gray-800 via-gray-900 to-black opacity-50" data-id="element-120"></div>

          <div className="relative p-10 md:p-16 lg:p-20 flex flex-col items-center text-center max-w-4xl mx-auto" data-id="element-121">
            <div className="w-16 h-16 bg-white/10 rounded-2xl flex items-center justify-center mb-8" data-id="element-122">
              <Handshake size={32} className="text-white" data-id="element-123" />
            </div>
            <h3 className="text-3xl md:text-4xl lg:text-5xl font-semibold mb-6 leading-tight" data-id="element-124">
              Спеціальні умови для партнерів
            </h3>
            <p className="text-gray-400 text-lg md:text-xl font-light mb-10 leading-relaxed max-w-2xl" data-id="element-125">
              Запрошуємо до співпраці агентства нерухомості, нотаріусів,
              ріелторів та адвокатів. Для вашої зручності при постійній
              співпраці відправляємо нашу печатку.
            </p>
            <div data-id="element-126">
              <a href="tel:+380971264678" className="inline-flex items-center justify-center px-8 py-4 text-base font-medium text-gray-900 bg-white rounded-full hover:bg-gray-100 transition-all duration-300 hover:scale-105" data-id="element-127">
                Обговорити співпрацю
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}